import { catalogApi } from "./config";

const askAssistant = async (question, skill = "general") => {
  try {
    const { data } = await catalogApi.get("/api/v1/assistant/chat", {
      params: { q: question, skill },
    });
    return data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "No se pudo obtener respuesta del asistente.";
    throw new Error(message);
  }
};

const getAssistantSkills = async () => {
  const { data } = await catalogApi.get("/api/v1/assistant/skills");
  return data;
};

const getAssistantStatus = async () => {
  const { data } = await catalogApi.get("/api/v1/assistant/status");
  return data;
};

export { askAssistant, getAssistantSkills, getAssistantStatus };
